<script setup lang="ts">
import type { NavigationLinkFragment } from '#graphql-operations'

interface SubmenuMobileSimpleProps {
  children: NavigationLinkFragment[]
}

defineProps<SubmenuMobileSimpleProps>()
</script>

<template>
  <ul class="grid space-y-2">
    <li v-for="link in children" :key="link.id" class="inline-flex">
      <ButtonNavSubmenu :link />
    </li>
  </ul>
</template>
